// /beta-tos: v0.1's address for the beta agreement (legacy /beta-tos,
// docs/parity/auth-public.md §2.4), which old emails and pages still link.
// /terms takes it from here: the gate for a chef who has terms to accept,
// else the public copy on /legal.
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/beta-tos')({
  beforeLoad: () => {
    throw redirect({ to: '/terms', replace: true });
  },
});
